const localeTexts = {
  404: {
    title: "404: Not Found",
    body: "The link you tried to access doesn't seem to exist. <br />Please verify and enter the correct URL.",
    button: {
      learnMore: "Learn more",
    },
  },
  AssetSidebarWidget: {
    title: "Asset Sidebar Widget",
    body: "This is the location that contains your Asset Sidebar Widget. <br />Create your new app now!",
    button: {
      learnMore: "Learn more",
    },
  },
  ConfigScreen: {
    title: "App Configuration",
    body: "This is the location that contains your App Configuration. <br />Create your new app now!",
    button: {
      learnMore: "Learn more",
    },
  },
  CustomField: {
    title: "Custom Field",
    body: "This is the location that contains your Custom Field. <br />Create your new app now!",
    button: {
      learnMore: "Learn more",
    },
  },
  DashboardWidget: {
    title: "Dashboard Widget",
    body: "This is the location that contains your Dashboard Widget. <br />Create your new app now!",
    button: {
      learnMore: "Learn more",
    },
  },
  SidebarWidget: {
    title: "Sidebar Widget",
    body: "This is the location that contains your Entry Sidebar Widget. <br />Create your new app now!",
    button: {
      learnMore: "Learn more",
    },
  },
  FullPage: {
    title: "Full Page App",
    body: "This is the location that contains your Full Page app. <br />Create your new app now!",
    button: {
      learnMore: "Learn more",
    },
  },
  FieldModifier: {
    title: "Field Modifier App",
    body: "This is the location that contains your Field Modifier app. <br />Create your new app now!",
    button: {
      learnMore: "Learn more",
    },
  },
};

export default localeTexts;
